import { getLocalSchedulesService } from "../../services/gets";

export interface ILocalDayHours {
  open: number;
  close: number;
}
export type ILocalHoursMap = Record<string, ILocalDayHours>;

// Fallback cuando un dia no tiene horario configurado en el local: 8:00 AM - 10:00 PM.
const FALLBACK_OPEN = 8;
const FALLBACK_CLOSE = 22;

// Mapeo idcodigodia -> nombre de dia (debe coincidir con los nombres usados por
// el adapter de horarios del empleado y por el componente compartido ScheduleRow).
const DAY_BY_CODE: Record<number, string> = {
  1: "Domingo",
  2: "Lunes",
  3: "Martes",
  4: "Miércoles",
  5: "Jueves",
  6: "Viernes",
  7: "Sábado",
};

const DAY_NAMES = [
  "Lunes",
  "Martes",
  "Miércoles",
  "Jueves",
  "Viernes",
  "Sábado",
  "Domingo",
];

// Convierte "HH:MM:SS" / "HH:MM" a hora decimal de 24h. Devuelve null si es invalido.
const timeToDecimal = (time: string): number | null => {
  if (!time || typeof time !== "string") return null;
  const parts = time.split(":");
  const hours = Number(parts[0]);
  const minutes = Number(parts[1] ?? 0);
  if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;
  return hours + minutes / 60;
};

export const buildFallbackMap = (): ILocalHoursMap => {
  const map: ILocalHoursMap = {};
  DAY_NAMES.forEach((day) => {
    map[day] = { open: FALLBACK_OPEN, close: FALLBACK_CLOSE };
  });
  return map;
};

/**
 * Obtiene el horario de atencion del local y lo transforma en un mapa de limites
 * por nombre de dia para limitar las opciones del selector de horarios del empleado.
 * Los dias sin horario valido en el local usan el fallback 8:00 AM - 10:00 PM.
 */
export const getLocalHoursAdapter = async (
  idLounge: number
): Promise<ILocalHoursMap> => {
  const localHours = buildFallbackMap();

  if (!idLounge) return localHours;

  const response = await getLocalSchedulesService(idLounge);
  const schedules = Array.isArray(response?.data) ? response.data : [];

  schedules.forEach((item: any) => {
    const code = item?.idCodeDay ?? item?.idcodigodia;
    const dayName = DAY_BY_CODE[Number(code)];
    if (!dayName) return;

    const open = timeToDecimal(item?.opening ?? item?.apertura);
    const close = timeToDecimal(item?.closing ?? item?.cierre);

    // Solo sobrescribe el fallback si el dia tiene un rango horario valido.
    if (open !== null && close !== null && close > open) {
      localHours[dayName] = { open, close };
    }
  });

  return localHours;
};
